<script lang="ts">
export default {
  name: 'CardDescription',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
}

const props = defineProps<Props>();

const descriptionClass = computed(() => cn('tw:text-sm tw:text-muted-foreground', props.class));
</script>

<template>
  <p :class="descriptionClass">
    <slot />
  </p>
</template>
